$(document).ready(function () {
    if ( $('.animate-text').length ) {
      $('.animate-text span:not(.hero-letter-arrow)').each( function (i, span) {
        setTimeout( function () {
          $(span).addClass('active')
        }, 300 * i )
      })
    }

    if ( $('.module__content-viz').length ) {
      $('.module__content-viz .sub-nav__link').on('click', function (e) {
        e.preventDefault();
        const handle = $(this).attr('href')
        selectContentVizSection(handle)
      })
    }

})

if (window.Shopify && Shopify.designMode) {
  const animatedTextTimers = new WeakMap()

  function replayAnimatedText (root) {
    const headings = root.querySelectorAll('.animate-text')

    headings.forEach(function (heading) {
      const spans = heading.querySelectorAll('span:not(.hero-letter-arrow)')
      if (!spans.length) return

      const previousTimers = animatedTextTimers.get(heading) || []
      previousTimers.forEach(clearTimeout)

      spans.forEach(function (span) {
        span.classList.remove('active')
      })

      // Commit the reset state before re-adding active so CSS transitions replay.
      void heading.offsetWidth

      const timers = []
      spans.forEach(function (span, index) {
        timers.push(setTimeout(function () {
          span.classList.add('active')
        }, 100 + (300 * index)))
      })
      animatedTextTimers.set(heading, timers)
    })
  }

  document.addEventListener('shopify:section:load', function (event) {
    replayAnimatedText(event.target)
  })
}

function selectContentVizSection (handle) {  
  if ( !$(`#content-viz-link-${handle}`).closest('.sub-nav-item').hasClass('sub-nav-item--active') ) {
    $('.sub-nav-item--active').removeClass('sub-nav-item--active')
    $(`#content-viz-link-${handle}`).closest('.sub-nav-item').addClass('sub-nav-item--active')
    $('.content-viz__slide.active').removeClass('active')
    $(`#content-viz-${handle}`).addClass('active')
    $('#blog-categories').val(handle)
  }
}
